import { create } from 'zustand';

type UtilStore = {
  isLoading: boolean;
  setLoading: (isLoading: boolean) => void;
};

const useUtilStore = create<UtilStore>(set => ({
  isLoading: false,
  setLoading: (isLoading: boolean) => set({ isLoading }),
}));

export default useUtilStore;
